export const SAVE_PERSONALITY_QUESTIONS = 'SAVE_PERSONALITY_QUESTIONS';
export const SAVE_USER_ANSWERS = 'SAVE_USER_ANSWERS';
export const SAVE_CURRENT_STEPS = 'SAVE_CURRENT_STEPS';
export const DELETE_ALL_PERSONALITY_QUES_DATA = "DELETE_ALL_PERSONALITY_QUES_DATA";
